/** `integrationType` of the Wix Forms slot integration registered with the ricos slot plugin. */
export const FORMS_INTEGRATION_TYPE = 'wix.forms.form';
/** Namespace the Wix Forms app stores site forms under. */
export const WIX_FORMS_NAMESPACE = 'wix.form_app.form';
/** Page size used when listing the site's forms. */
export const FORMS_PAGE_SIZE = 100;
/**
 * The ricos slot node type (`SLOT_TYPE` in `@wix/ricos`). A literal rather than an import: this
 * module runs in the OOI controller worker, which must not pull in `@wix/ricos`.
 */
export const FORMS_SLOT_NODE_TYPE = 'SLOT';
/** Upper bound on `listForms` pages the picker follows (`FORMS_PAGE_SIZE` forms each). */
export const MAX_LIST_FORMS_PAGES = 10;
/** How long the post page waits for its forms before rendering without them. */
export const FORMS_PRELOAD_TIMEOUT_MS = 4000;
/**
 * Wix Forms' own default grid gap, from `ui/form/components/grid/grid.module.scss`
 * (`gap: var(--wix-forms-formRowSpacing, 24px)`).
 *
 * The design panel shows it while the gaps are unset, and the loading placeholder spaces its rows
 * by it, so both agree with what Forms actually renders.
 */
export const FORMS_DEFAULT_GAP_PX = 24;
//# sourceMappingURL=consts.js.map